import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { useCloneEncodeSpecificationForm } from "./useCloneEncodeSpecificationForm";

export interface CloneEncodeSpecificationFormProps {
    itemId: string;
    onCancel(): void;
    onSubmit(): void;
}

export interface CloneEncodeSpecificationFormInputs {
    name: string;
}

export const CloneEncodeSpecificationForm: FunctionComponent<CloneEncodeSpecificationFormProps> = (
    props: CloneEncodeSpecificationFormProps
) => {
    const { itemId, onCancel, onSubmit } = props;
    const { cloneEncodeSpecification } = useCloneEncodeSpecificationForm();

    const { errors, formState, control, reset, handleSubmit } = useForm<CloneEncodeSpecificationFormInputs>({
        defaultValues: {
            name: ""
        },
        criteriaMode: "all"
    });

    const handleCloneMuxSpecification = async (inputs: CloneEncodeSpecificationFormInputs) => {
        await cloneEncodeSpecification(itemId, inputs);
        onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCloneMuxSpecification)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{
                            required: "Name is required field"
                        }}
                    />
                </FormFields>
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={handleCancelButtonClick}
                />
            </Stack>
        </Form>
    );
};
